import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalInfo, Methodology } from '../../models';
import { ToastService, ToolService } from '../../services';

@Component({
    selector: 'app-add-methodology',
    templateUrl: './add-methodology.component.html',
    styleUrls: ['./add-methodology.component.scss'],
    standalone: false
})
export class AddMethodologyComponent implements OnInit {

  @Input() data: ModalInfo;
  // It is used to know if the parent component has been submitted
  didSubmit: boolean;
  @Input('didSubmit') set setDidSubmit(attribute: boolean | '') {
    this.didSubmit = attribute === '' || attribute;
  }

  @Output() sendStatusToParent = new EventEmitter<Methodology>();

  list: Methodology;
  methodologies: Methodology[];

  constructor(
    private toastService: ToastService,
    private toolService: ToolService) { }

  async ngOnInit() {
    try {
      await this.getMethodologies(this.data.id_entity, this.data.id_parent);
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Get the methodologies list
   * @param idExecution Execution id
   * @param idAggregation Aggregation id
   */

  async getMethodologies(idExecution: string, idAggregation: string) {
    this.methodologies = (await this.toolService.getMethodology(idExecution, idAggregation)).methodologies;
  }

  /**
   * Get the methodology selected by the select. Send the list to the parent component
   * @param $event Methodology selected
   */

  getValue($event: Methodology) {
    this.methodologies.map(meth => {
      if ($event) {
        meth.isChecked = meth.type === $event.type;
      } else {
        meth.isChecked = false;
      }
    });
    this.sendStatusToParent.emit(this.list);
  }
}
